"use client";

import styled from "styled-components";
import { sans as zoram, lineHeight, fontSize13, fontWeightBold, fontWeightNormal } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
import { jsx as _jsx } from "react/jsx-runtime";
const Container5 = styled.div.withConfig({
  componentId: "sc-1wnkqiv-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, fontWeightNormal, lineHeight, fontSize13, shared, fontWeightBold);

/**
 * `Text5` (Citation) is for text that people will want to read and is required legally.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Text content
 * @param {React.ElementType} [props.renderAs] - HTML tag or custom React element to render as
 * @returns {React.ReactElement} The Text5 component
 */
const Text5 = ({
  children,
  renderAs = "div",
  ...props
}) => /*#__PURE__*/_jsx(Container5, {
  as: renderAs,
  ...props,
  children: children
});
Text5.displayName = "Text5";
export default Text5;